import React from 'react';
import { Stytch } from '@stytch/stytch-react';

// IF I WANNA ADD MORE SOCIAL OPTIONS, ID JUST ADD TO THE PROVIDERS ARRAY AN OBJECT OF THE TYPE AND REGISTER AUTHORIZATION W THEM

const StytchLogin = () => {
  const STYTCH_PUBLIC_TOKEN =
    'public-token-test-82bb08a5-9831-4672-a529-e845c1801347';
  const stytchProps = {
    loginOrSignupView: {
      products: ['oauth'],
      oauthOptions: {
        providers: [
          {
            type: 'google',
            one_tap: true,
            position: 'embedded',
          },
        ],
      },
    },
    publicToken: STYTCH_PUBLIC_TOKEN,
  };

  return (
    <div className="sign-in-container">
      <Stytch
        publicToken={stytchProps.publicToken}
        loginOrSignupView={stytchProps.loginOrSignupView}
      />
    </div>
  );
};

export default StytchLogin;
